import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { CreateMovimientoExpedienteRequest } from '@models/movimientoExpediente/createMovimientoExpedienteRequest.model';
import { MovimientoExpedienteDto } from '@models/movimientoExpediente/movimientoExpedienteDto.model';
import { UpdateMovimientoExpedienteRequest } from '@models/movimientoExpediente/updateMovimientoExpedienteRequest.model';
import { EstadoMovimientoExpedienteService } from '@services/estadoMovimientoExpediente/estadoMovimientoExpediente.service';
import { LoginService } from '@services/login/login.service';
import { MovimientoExpedienteService } from '@services/movimientoExpediente/movimientoExpediente.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { BuscarPersonaComponent } from '@views/busquedas/buscar-persona/buscar-persona.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';

@Component({
  selector: 'app-dialog-form-movimiento-expediente',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCloseDialogComponent, AppRolesDirective, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent],
  templateUrl: './dialog-form-movimiento-expediente.component.html',
  styleUrl: './dialog-form-movimiento-expediente.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormMovimientoExpedienteComponent {
  expedienteDto!: ExpedienteSummaryDto;
  estadosMovimientoExpediente!: BaseDto[];

  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  tiposmovimientoExpediente!: BaseDto[];
  movimientoExpedienteDto!: MovimientoExpedienteDto;

  constructor(
    public dialogRef: MatDialogRef<DialogFormMovimientoExpedienteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private estadoMovimientoExpedienteService: EstadoMovimientoExpedienteService,
    private movimientoExpedienteService: MovimientoExpedienteService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
  ) {

    this.getAllEstadosMovimientoExpediente();
  }

  ngOnInit(): void {
    const movimientoExpediente = this.data?.item || {};

    this.form = this.formBuilder.group({
      Descripcion: [movimientoExpediente.descripcion || '', Validators.compose([Validators.required, Validators.maxLength(200)])],
      Id: [movimientoExpediente.id || ''],
      Observaciones: [movimientoExpediente.observaciones || ''],
      IdEstadoMovimientoExpediente: [movimientoExpediente.estadoMovimientoExpediente?.id || '', Validators.compose([Validators.required])],
      IdEscrito: [movimientoExpediente.escrito?.id || null],
      IdArchivo: [movimientoExpediente.archivo?.id || null],
      IdExpediente: [movimientoExpediente.expediente?.id || null, Validators.compose([Validators.required])],
      Fecha: [movimientoExpediente.fecha || null, Validators.compose([Validators.required])],

    });

    if (this.data.idExpediente)
    {
      this.form.controls['IdExpediente'].setValue(this.data.idExpediente)
      this.expedienteDto.id = this.data.idExpediente
    }

  }


  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }

  getAllEstadosMovimientoExpediente() {
    this.spinner.show("spTiposmovimientoExpediente")
    this.estadoMovimientoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposmovimientoExpediente")
          this.estadosMovimientoExpediente = data
        },
        error => {
          this.spinner.hide("spTiposmovimientoExpediente")
          this.snackBar.showError(error, "Error");
        })
  }


  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spMovimientoExpediente")
    this.movimientoExpedienteService.create(this.setCreateMovimientoExpedienteRequest())
      .subscribe(
        data => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.movimientoExpediente, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spMovimientoExpediente")
    this.movimientoExpedienteService.update(this.setUpdateMovimientoExpedienteRequest())
      .subscribe(
        data => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.movimientoExpediente, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spMovimientoExpediente")
    this.movimientoExpedienteService.delete(this.data.item.id)
      .subscribe(
        data => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.movimientoExpediente, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spMovimientoExpediente")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateMovimientoExpedienteRequest(): CreateMovimientoExpedienteRequest {

    const createMovimientoExpedienteRequest = new CreateMovimientoExpedienteRequest();

    createMovimientoExpedienteRequest.descripcion = this.form.controls['Descripcion'].value;
    createMovimientoExpedienteRequest.observaciones = this.form.controls['Observaciones'].value;
    createMovimientoExpedienteRequest.idEstadoMovimientoExpediente = this.form.controls['IdEstadoMovimientoExpediente'].value;
    createMovimientoExpedienteRequest.idExpediente = this.form.controls['IdExpediente'].value;
    createMovimientoExpedienteRequest.fecha = this.form.controls['Fecha'].value;
    createMovimientoExpedienteRequest.idEscrito = this.form.controls['IdEscrito'].value || null;
    createMovimientoExpedienteRequest.idArchivo = this.form.controls['IdArchivo'].value || null;

    return createMovimientoExpedienteRequest
  }

  setUpdateMovimientoExpedienteRequest(): UpdateMovimientoExpedienteRequest {

    const updateMovimientoExpedienteRequest = new UpdateMovimientoExpedienteRequest();
    updateMovimientoExpedienteRequest.id = this.form.controls['Id'].value;
    updateMovimientoExpedienteRequest.descripcion = this.form.controls['Descripcion'].value;
    updateMovimientoExpedienteRequest.observaciones = this.form.controls['Observaciones'].value;
    updateMovimientoExpedienteRequest.idEstadoMovimientoExpediente = this.form.controls['IdEstadoMovimientoExpediente'].value;
    updateMovimientoExpedienteRequest.idExpediente = this.form.controls['IdExpediente'].value;
    updateMovimientoExpedienteRequest.fecha = this.form.controls['Fecha'].value;
    updateMovimientoExpedienteRequest.idEscrito = this.form.controls['IdEscrito'].value || null;;
    updateMovimientoExpedienteRequest.idArchivo = this.form.controls['IdArchivo'].value || null;;

    return updateMovimientoExpedienteRequest
  }

  onReset() {
    this.form.reset();
  }

  trackBymovimientoExpedientes(index: number, movimientoExpediente: any): any { return movimientoExpediente; }



  async getmovimientoExpedienteById(id: number) {
    this.spinner.show("spView")
    await this.movimientoExpedienteService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.movimientoExpedienteDto = data
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}
